import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const c = landingPages["directeur-marketing-externalise"]!.en!;

export const Route = createFileRoute("/en/outsourced-marketing-director")({
  head: () =>
    pageHead({
      path: "/en/outsourced-marketing-director",
      title: c.title,
      description: c.description,
      frPath: "/directeur-marketing-externalise",
      crumbs: [["Outsourced marketing director", "/en/outsourced-marketing-director"]],
      schemas: landingSchemas(c),
    }),
  component: () => <LandingPage pageKey="directeur-marketing-externalise" forceLanguage="en" pathOverride="/en/outsourced-marketing-director" />,
});
